import styled from 'styled-components';
import { Table } from 'elements/Table';

const Board = styled(Table)(({ theme, isComplete }) => `
  transition: all ${theme.speeds.moderate};
  outline: ${theme.strokes.small} solid transparent;
  outline-offset: ${theme.strokes.medium};
  ${isComplete ? `
    outline: ${theme.strokes.small} solid ${theme.colors.dark};
  ` : ''}
`);

export default Board;
